import { useEffect, useState } from "react";
import { getRequirementByRecruiterId } from "../../../../endpoints/hiringCompany/requirements";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { getJobStatusLabel } from "../../../../utils/helperFunction";
import LoadingAnimation from "../../../../assets/svg/LoadingAnimation";

const Requirements = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [isRequirementsLoading, setIsRequirementsLoading] = useState(true);
  const [requirementList, setRequirementList] = useState([]);

  const fetchRequirements = async (recruiterId: string) => {
    try {
      setIsRequirementsLoading(true);
      const { success, data } = await getRequirementByRecruiterId(recruiterId);
      if (success) {
        setRequirementList(data);
      }
    } catch (error) {
      console.error("Error fetching requirements", error);
    } finally {
      setIsRequirementsLoading(false);
    }
  };

  useEffect(() => {
    if (params?.agentId) {
      fetchRequirements(params?.agentId);
    }
  }, [location?.search]);

  if (isRequirementsLoading) {
    return (
      <div className="flex flex-grow-0 items-center justify-center h-full">
        <LoadingAnimation color="black" />
      </div>
    );
  }

  return (
    <div className="mt-5 h-full">
      <div className="flex  items-center w-full gap-8 bg-[#F1F5F9] rounded-lg px-3 py-3 mb-3">
        <span className="font-semibold text-xs">Elite Staffing Solutions</span>
        <div className="bg-white rounded-md text-xs font-medium text-light-black py-2 px-4">
          CA-FQ1478
        </div>
      </div>
      {requirementList?.length ? (
        <table className="min-w-full text-xs text-left">
          <thead className="border-b border-[#E0E0E0]">
            <tr className="font-semibold">
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                Job title
              </th>
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                Published date
              </th>
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                Recruitment agent
              </th>
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">Status</th>
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                Applied candidates
              </th>
              <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                Reference
              </th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {requirementList?.map((job, idx) => (
              <tr
                key={idx}
                className="border-t  border-gray-100 cursor-pointer hover:bg-gray-50"
                onClick={() =>
                  navigate(
                    `/recruitment-agents/${params?.agentId}/job/${job?._id}`
                  )
                }
              >
                <td className="py-6 text-xs font-medium text-[#6F6F6F] ">
                  {job.title}
                </td>
                <td className="py-6 text-xs font-medium text-[#6F6F6F]">
                  {dayjs(job.createdAt).format("Do MMMM YYYY")}
                </td>
                <td className="py-6 text-xs text-[#6F6F6F]">-</td>
                <td className="py-6 text-xs text-[#6F6F6F] capitalize">
                  {getJobStatusLabel(job.status)}
                </td>
                <td className="flex py-4 text-xs text-[#6F6F6F]">
                  <div className="relative inline-flex ml-10 self-center items-center justify-center w-8 h-8 rounded-full border border-gray-400 text-sm">
                    {job.totalSubmittedCandidates ?? 0}
                    {job.applied > 0 && (
                      <span className="absolute -top-1 -right-1 text-[8px] w-4 h-4 justify-center items-center flex text-white font-bold bg-green-500 rounded-full border-2 border-white">
                        2
                      </span>
                    )}
                  </div>
                </td>
                <td className="py-6 text-xs text-[#6F6F6F]">{job.refNo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="items-center justify-center flex h-full">
          <span className="font-medium text-sm text-light-black">
            No data found.
          </span>
        </div>
      )}
    </div>
  );
};

export default Requirements;
